import React from 'react';

import { useFeatureFlag } from '~/src/common/services/FeatureFlag';
import I18n from '~/src/common/services/I18n';
import { ProductDetailed } from '~/src/common/typings/product';
import { sanitize } from '~/src/common/utils/text';

import ProductGenericInformation from '../ProductGenericInformation';

import * as S from './layout';

interface Props {
  className?: string;
  product: ProductDetailed;
}

const ProductInformation = ({ className, product }: Props) => {
  const isNewFocus = useFeatureFlag('configuration-page-produit') !== 'old';

  const { description, shortDescription } = product;

  // Quand la description est vide, actuellement l'api renvoie <p></ br></p> (pb au niveau composant RichText à priori)
  const isDescriptionEmpty = !description || !sanitize(description);

  return (
    <S.Container className={className}>
      <S.Content>
        {!isNewFocus ? (
          <>
            <S.Waves />
            {shortDescription ? (
              <S.Usage>
                <p>{shortDescription}</p>
              </S.Usage>
            ) : null}
          </>
        ) : null}

        {!isDescriptionEmpty ? (
          <ProductGenericInformation
            content={description}
            title={I18n.t('view-product-screen.description')}
          />
        ) : null}
      </S.Content>
    </S.Container>
  );
};

export default ProductInformation;
